// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.planning, .prototyping, .development, .deployment {
    background: #eee;
}

.discovery-content, .planning-content, .prototyping-content, .development-content, .deployment-content {
    display: flex;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/dev-process/dev-process.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".planning, .prototyping, .development, .deployment {\n    background: #eee;\n}\n\n.discovery-content, .planning-content, .prototyping-content, .development-content, .deployment-content {\n    display: flex;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
